import {Component, OnInit, Output, EventEmitter, ElementRef} from '@angular/core';

declare var TiltFx, TimelineMax, TweenMax, Power2, Sine;

@Component({
    selector: 'app-projects',
    templateUrl: './projects.component.html',
    styleUrls: ['./projects.component.less']
})
export class ProjectsComponent implements OnInit {
    @Output() animOpenSectionEnded: EventEmitter<any> = new EventEmitter();
    @Output() animCloseSectionEnded: EventEmitter<any> = new EventEmitter();

    isComponentLoading: boolean = true;

    tl_projects: any;
    animatedElems: any = {};

    constructor(private elRef: ElementRef) {
    }

    ngOnInit() {
        let _this = this;
        this.animOpenSectionEnded.emit();

        this.tl_projects = new TimelineMax({
            paused: true,
            repeat: 0,
            force3d: true,
            onComplete(){
                _this.isComponentLoading = false;
            },
            onReverseComplete(){
                // _this.animCloseSectionEnded.emit();
            }
        });

        // TweenMax.set(this.imgPerspectiveComponent.animatedElems.imgElem, {autoAlpha:0});
    }

    ngOnDestroy() {
        this.tl_projects.kill();
        this.tl_projects = null;
    }

    ngAfterViewInit() {
        this.setupElems();
        this.tl_setupAnimIntro();

        setTimeout(()=> {
            this.tl_projects.play();
        }, 10);
    }

    setupElems(){
        // this.animatedElems.title = jQuery('[line-web-developer]', this.elRef.nativeElement);
    }

    componentAnimOut(){
        this.tl_projects.reverse();
        setTimeout(()=> { this.animCloseSectionEnded.emit(); }, 1600);
    }

    tl_setupAnimIntro(){
        // this.tl_projects.add("anim_fadeToLeft", 0.1);
        // this.tl_projects.add(arrayAnims, "anim_fadeToLeft");
    }

}



// WEBPACK FOOTER //
// /Users/davidlagace/Sites/david-lagace-website/src/app/projects/projects.component.ts